// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CountBadge_wrapper___YjAm","countBadge":"CountBadge_countBadge__Q5j_m"};